import { Component } from '@verndale/core';

class ExitIntentModal extends Component {
  targetedUrl = '';
  backgroundElements: NodeListOf<HTMLElement>;

  constructor(el: HTMLElement) {
    super(el);
    this.backgroundElements = document.querySelectorAll('header,main,footer,.consentbanner');
  }

  setupDefaults() {
    this.dom = {
      triggers: document.querySelectorAll('a'),
      modal: this.el.querySelector('.modal-dialog') as HTMLElement,
      close: this.el.querySelector('.btn-close') as HTMLElement,
      proccedButton: this.el.querySelector('.modal-cta button') as HTMLButtonElement,
      description: this.el.querySelector('.modal-description') as HTMLElement
    };
  }

  addListeners(): void {

    document.body.addEventListener('click', (e: Event) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a');
      if (link && link.href) {
        this.openModal(link as unknown as HTMLLinkElement, e);
      }
    });
    (this.dom.close as HTMLElement).addEventListener('click', this.closeModal.bind(this));
    (this.dom.proccedButton as HTMLButtonElement).addEventListener(
      'click',
      this.proceedButton.bind(this)
    );
  }

  openModal(el: HTMLLinkElement, e: Event) {
    const f = this.dom.modal as HTMLElement;
    const excludeList = f.getAttribute('data-exclude-list')?.split(',');
    excludeList?.push(document.location.hostname);
    const linkElement = el;
    const targetUrl = new URL(linkElement.href);
    if (targetUrl.hostname.trim() != '' && !excludeList?.includes(targetUrl.hostname)) {
      f.classList.remove('hide');
      e.preventDefault();
      const ctaButton = this.dom.proccedButton as HTMLButtonElement;
      const descriptionElement = (this.dom.description as HTMLElement) || null;
      if (descriptionElement) {
        descriptionElement.textContent = descriptionElement.textContent!.replace(
          '$url',
          targetUrl.hostname
        );
      }
      this.targetedUrl = targetUrl.hostname;
      ctaButton.setAttribute('data-target-url', targetUrl.href);
      if (linkElement.target) {
        ctaButton.setAttribute('data-target', linkElement.target);
      } else {
        ctaButton.removeAttribute('data-target');
      }
      this.backgroundElements.forEach(el => {
        el.setAttribute('inert', 'true');
      });
    }

  }

  updateDescription() {
    const descriptionElement = (this.dom.description as HTMLElement) || null;
    if (descriptionElement && this.targetedUrl != '') {
      descriptionElement.textContent = descriptionElement.textContent!.replace(
        this.targetedUrl,
        '$url'
      );
    }
  }

  closeModal() {
    const f = this.dom.modal as HTMLElement;
    f.classList.add('hide');
    this.updateDescription();
    this.backgroundElements.forEach(el => {
      el.removeAttribute('inert');
    });
  }

  proceedButton(e: Event) {
    this.closeModal();
    const proccedButton = e.target as HTMLElement;
    const targetUrl = proccedButton.getAttribute('data-target-url')!;
    const target = proccedButton.getAttribute('data-target')!;
    window.open(targetUrl, target);
    this.updateDescription();
  }
}
export default ExitIntentModal;
